<template>
    <div id="userList">
        <!-- <p class="company-bin" @click="toUserList" id="toList"><i><img :src="zuo" class="zuo"></i>用户回收站</p> -->
        <p class="view-title">用户管理</p>
        <div class="organize">
            <organize @setOrId="setOrId(arguments)" :recoveryName="recoveryName" @recovery="recovery" @setTree="setTree"></organize>
        </div>
        <!-- 列表 -->
        <div class="list-box" v-show="!isBin" style="top: 77px;">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>全部</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>正常</span></div>
                <div :class="{'active':state==2}" @click="headClick(2)" id="headClick2"><span>停用</span></div>
                <div :class="{'active':state==3}" @click="headClick(3)" id="headClick3"><span>冻结</span></div>
                <div :class="{'active':state==4}" @click="headClick(4)" id="headClick4"><span>未激活</span></div>
            </header>
            <div class="bg t-0">
                <div class="list-top clearfix">
                    <el-button type="primary" class="add-btn" @click="VerifyArr.includes(3)?$store.state.mask=functionShow = true:addShow=$store.state.mask=true" id="addUserBtn" :disabled="!functionSet.includes('userEdit')||$store.state.isLook">新建用户</el-button>
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="search" id="searchBtn">搜索</el-button>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入账号或姓名"
                            v-model="searchVal" class="search-input" id="searchUserVal" @keyup.enter.native="search">
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li style="margin-left: 3%;">账号</li>
                        <li class="w-18">姓名</li>
                        <li class="w-18">角色</li>
                        <li>分组</li>
                        <li class="w-90  min-44">账号状态</li>
                        <li class="w-90  min-44">在线状态</li>
                        <li class="w-26 min-188">操作</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                            <li style="margin-left: 3%;" :title="item.userName">{{item.userName}}</li>
                            <li class="w-18" :title="item.displayName">{{item.displayName}}</li>
                            <li class="w-18" :title="item.roleNameSet">{{item.roleNameSet}}</li>
                            <li :title="item.groupName">{{item.groupName}}</li>
                            <li class="w-90 min-44" :class="{'color-red':item.loginState ==2||item.activeState=='2'||item.state==2}">{{item.loginState==2?'冻结':item.activeState==2?'未激活':item.state==1?"正常":"停用"}}</li>
                            <li class="w-90 min-44">{{item.onlineState==1?"在线":"离线"}}</li>
                            <li class="operate w-26 min-188">
                                <span @click="operate(item,'edit',i)" :id="`editUser${i}`">{{functionSet.includes('userEdit')&&item.id!=$store.state.userData.id&&!$store.state.isLook?'编辑':'查看'}}</span>
                                <span :class="{'disabled':!functionSet.includes('userEdit')||item.userName==$store.state.userData.userName||$store.state.isLook}" @click="operate(item,'del',i)" :id="`delUser${i}`">删除</span>
                                <span :class="{'disabled':!functionSet.includes('userEdit')||item.userName==$store.state.userData.userName||$store.state.isLook}" @click="operate(item,'enable',i)" :id="`enableUser${i}`" v-show="item.state==2">启用</span>
                                <span :class="{'disabled':!functionSet.includes('userEdit')||item.userName==$store.state.userData.userName||$store.state.isLook}" @click="operate(item,'disable',i)" :id="`disableUser${i}`" v-show="item.state==1">停用</span>
                                <span :class="{'disabled':!functionSet.includes('userEdit')||item.userName==$store.state.userData.userName||$store.state.isLook}" @click="operate(item,'reset',i)" :id="`resetUser${i}`">重置</span>
                                <span :class="{'disabled':!functionSet.includes('userEdit')||item.userName==$store.state.userData.userName||$store.state.isLook}" @click="operate(item,'unfreeze',i)" :id="`unfreezeUser${i}`" v-show="item.loginState==2">解冻</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
        <!-- 回收站 -->
        <div class="list-box" v-show="isBin">
            <div class="bg t-0">
                <div class="list-top clearfix">
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="searchBin" id="searchBinBtn">搜索</el-button>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="search"
                            v-model="searchBinVal" class="search-input" @keyup.enter.native="searchBin">
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li >账号</li>
                        <li class="w-18">姓名</li>
                        <li class="w-18">角色</li>
                        <li>分组</li>
                        <li class="w-90">账号状态</li>
                        <li class="w-90">在线状态</li>
                        <li class="w-90">操作</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in recoveryList" :key="i" v-show="recoveryList.length!=0">
                            <li >{{item.userName}}</li>
                            <li class="w-18" :title="item.displayName">{{item.displayName}}</li>
                            <li class="w-18" :title="item.roleNameSet">{{item.roleNameSet}}</li>
                            <li :title="item.groupName">{{item.groupName}}</li>
                            <li class="w-90">{{item.state==1?"正常":"禁用"}}</li>
                            <li class="w-90">{{item.onlineState==1?"在线":"离线"}}</li>
                            <li class="operate w-90">
                                <span @click="operate(item,'recovery',i)" :id="`recoveryUser${i}`">恢复</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="recoveryList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 恢复用户 -->
            <div class="popup-delDevice" v-show="recoveryShow">
                <div class="popup-title">
                    恢复用户<i class="el-icon-circle-close close" @click="close('recovery')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将恢复该用户"{{nowObj.displayName}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')" @click="recoveryUser">确定</el-button> <el-button @click="close('recovery')">取消</el-button></p>
                </div>
            </div>
            <!-- 解冻账号 -->
            <div class="popup-unfreeze" v-show='unfreezeShow'>
                <div class="popup-title">
                    解冻账号<i class="el-icon-circle-close close" @click="close('unfreeze')" id="closeUnfreeze"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将解冻该用户账号 “ {{nowObj.displayName}} ”，是否继续
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')" @click='unfreeze' id="yesUnfreeze">确定</el-button> <el-button @click="close('unfreeze')" id="noUnfreeze">取消</el-button></p>
                </div>
            </div>
            <!-- 启用账号 -->
            <div class="popup-enable" v-show='enableShow'>
                <div class="popup-title">
                    启用账号<i class="el-icon-circle-close close" @click="close('enable')"  id="closeEnable"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将启用该用户账号 “ {{nowObj.displayName}} ”，是否继续
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')" @click='enable' id="yesEnable">确定</el-button> <el-button @click="close('enable')" id="noEnable">取消</el-button></p>
                </div>
            </div>
            <!-- 删除用户 -->
            <div class="popup-enable" v-show='delShow'>
                <div class="popup-title">
                    删除用户<i class="el-icon-circle-close close" @click="close('del')" id="colseDel"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将删除该用户 " {{nowObj.displayName}} "，是否继续
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')" @click='del' id="yesDel">确定</el-button> <el-button @click="close('del')" id="noDel">取消</el-button></p>
                </div>
            </div>
            <!-- 停用账号 -->
            <div class="popup-enable" v-show='disableShow'>
                <div class="popup-title">
                    停用账号<i class="el-icon-circle-close close" @click="close('disable')" id="closeDisable"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将停用该账号 “ {{nowObj.displayName}} ”，是否继续
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')" @click='disable' id="yesDisable">确定</el-button> <el-button @click="close('disable')" id="noDisable">取消</el-button></p>
                </div>
            </div>
            <!-- 重置 -->
            <div class="popup-enable" v-show='resetShow'>
                <div class="popup-title">
                    提示<i class="el-icon-circle-close close" @click="close('reset')" id="closeReset"></i>
                </div>
                <div class="popup-lab t-left">
                    重置账号将重置密码、手机号、公众号绑定状态，是否继续
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')" @click='reset' id="yesReset">确定</el-button> <el-button @click="close('reset')" id="noReset">取消</el-button></p>
                </div>
            </div>
            <!-- 创建成功 -->
            <div class="popup-enable" v-show='successShow'>
                <div class="popup-title">
                    新建用户成功<i class="el-icon-circle-close close" @click="close('success')" id="closeSuccess"></i>
                </div>
                <div class="popup-lab t-left">
                  用户名：{{displayName}}，请凭账号: {{Account}} 密码: Ab123456 登录捷云物联平台: <span class="c-pointer"> {{protocol}}//iot.yonjie.com</span>，根据页面提示输入初始帐号信息，绑定手机号码
                    <span class="grey">（注意：第一次激活需要在PC浏览器完成）</span>，激活完成后也可以通过微信搜索：“捷云物联”小程序访问。<span class="copy" @click="copy" id="copy">复制</span>
                    <p class="btn-box"><el-button type="primary" @click="close('success')" id="yesSuccess">确定</el-button> <el-button @click="close('success')" id="noSuccess">取消</el-button></p>
                </div>
                <textarea class="copy-obj" ref="copyTxt">用户名：{{displayName}}，请凭账号: {{Account}} 密码: Ab123456 登录捷云物联平台: {{protocol}}//iot.yonjie.com，根据页面提示输入初始帐号信息，绑定手机号码（注意：第一次激活需要在PC浏览器完成），激活完成后也可以通过微信搜索：“捷云物联”小程序访问。</textarea>
            </div>
            <!-- 新增 -->
            <div class="popup-add" v-show="addShow">
                <div class="popup-title">
                    新建用户<i class="el-icon-circle-close close" @click="close('add')" id="closeAdd"></i>
                </div>
                <div class="popup-lab t-left">
                    <div>
                        <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix" :disabled="!functionSet.includes('userEdit')">
                            <div class="popup-left">
                                <p class="user-detail">用户基本信息</p>
                                <el-form-item prop="displayName" label="用户姓名：" class="no-title">
                                    <i><img :src="notes" title="用户姓名支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                    <el-input v-model="ruleForm.displayName" id="addDisName"></el-input>
                                </el-form-item>
                                <div class="popup-lab m-t-26">
                                    <p style="margin-left: -10px;"><i class="star" style="margin: 0;">*</i> 所属组织：<i><img :src="notes" title="组织层级最多支持10级" class="notes"></i></p>
                                    <div class="or-Superior" @click='showSelect' id="addSelect1" @mouseleave="selectShow=false">
                                        <span class="Superior-name">{{orSuperior.name}}</span>
                                        <i><img :src="down" @click="showSelect" id="addSelect2"></i>
                                        <div class="select-box tree" ref="selectbox" v-show='selectShow' >
                                            <div class="dashed">
                                                <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                                        <i><img :src="data.type == 1 ? branch1 : data.type == 2 ? location1 : area1" class="tree-icon"></i>
                                                        <span>{{ node.label }} <span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                                    </span>
                                                </el-tree>
                                            </div>
                                        </div>
                                    </div>
                                    <span ref="addOrMax" class="red addMax">操作失败，此操作将导致组织层级超过10级</span>
                                </div>
                                <el-form-item label="备注：">
                                    <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                    <el-input
                                        type="textarea"
                                        class="remarks"
                                        v-model="ruleForm.note"
                                        maxlength="256"
                                        show-word-limit
                                        id="addRemarks"
                                        placeholder="请输入内容">
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="popup-right">
                                <p class="user-detail">用户状态信息</p>
                                <el-form-item prop="roleNameSet" label="用户角色：" class="no-title">
                                    <i><img :src="notes" title="角色不能为空，支持多选" class="notes"></i>
                                    <div class="edit-role" @click="showRole('add')" id="addRole"><img :src="cssType==0? edit0 :edit1"> 编辑</div>
                                    <div class="role-box">
                                        <p class="role-list" v-for="role in addRoleList">
                                            <span v-if="role.type==1">{{role.name}}(通用)</span>
                                            <span v-if="role.type==2">{{role.name}}/{{role.groupName}}</span>
                                        </p>
                                    </div>
                                </el-form-item>
                                <div class="bottom-details">
                                    <p>公众号: 未绑定</p>
                                    <p>手机号: 未绑定</p>
                                </div>
                            </div>
                        </el-form>
                    </div>
                    <p class="btn-box"><el-button type="primary" @click="addUser('addForm')" id="yesAdd">确定</el-button> <el-button @click="close('add')" id="noAdd">取消</el-button></p>
                </div>
            </div>
            <!-- 编辑用户 -->
            <div class="popup-add" v-show="editShow">
                <div class="popup-title">
                    {{functionSet.includes('userEdit')&&ruleForm.userName!=$store.state.userData.userName?'编辑':'查看'}}用户<i class="el-icon-circle-close close" @click="close('edit')" id="closeEdit"></i>
                </div>
                <div class="popup-lab t-left">
                    <div>
                        <el-form :model='ruleForm' :rules="rules" :disabled="!functionSet.includes('userEdit')||ruleForm.id==$store.state.userData.id" ref="editForm" class="clearfix">
                            <div class="popup-left">
                                <p class="user-detail">用户基本信息</p>
                                <p class="l-h-23">账号: {{ruleForm.userName}}</p>
                                <el-form-item prop="displayName" label="用户姓名：" autocomplete="off" class="no-title">
                                    <i><img :src="notes" title="用户姓名支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                    <el-input v-model="ruleForm.displayName" id="editDisName"></el-input>
                                </el-form-item>
                                <div class="popup-lab m-b-5">
                                    <p style="margin-left: -10px;"><i class="star" style="margin: 0;">*</i> 所属组织：<i><img :src="notes" title="组织层级最多支持10级" class="notes"></i></p>
                                    <div class="or-Superior" @click='showSelect' id="editSelect1" v-show="functionSet.includes('userEdit')&&!$store.state.isLook&&ruleForm.id!=$store.state.userData.id">
                                        <span class="Superior-name">{{orSuperior.name}}</span>
                                        <i><img :src="down" @click="showSelect" id="editSelect2" @mouseleave="selectShow=false"></i>
                                        <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                            <!-- <p class="root-obj" @click.stop="selectId($store.state.data)" id="selectbox">{{$store.state.data.name}}</p></p> -->
                                            <div class="dashed">
                                                <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                                        <i><img :src="data.type == 1 ? branch1 : data.type == 2 ? location1 : area1" class="tree-icon"></i>
                                                        <span>{{ node.label }} <span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                                    </span>
                                                </el-tree>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="or-Superior disabled3" v-show="!functionSet.includes('userEdit')||$store.state.isLook||ruleForm.id==$store.state.userData.id">
                                        {{orSuperior.name}}
                                        <i><img :src="down"></i>
                                    </div>
                                    <span ref="addOrMax" class="red addMax">操作失败，此操作将导致组织层级超过10级</span>
                                </div>
                                <el-form-item label="备注：">
                                    <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                    <el-input
                                        type="textarea"
                                        class="remarks"
                                        v-model="ruleForm.note"
                                        maxlength="256"
                                        show-word-limit
                                        id="editRemarks"
                                        placeholder="请输入内容">
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="popup-right">
                                <p class="user-detail">用户状态信息</p>
                                <el-form-item prop="roleSet" label="用户角色：" class="no-title">
                                    <i><img :src="notes" title="角色不能为空，支持多选" class="notes"></i>
                                    <div class="edit-role" @click="showRole('add')" id="editRole"><img :src="cssType==0? edit0 :edit1"> 编辑</div>
                                    <div class="role-box" style="height: 160px;">
                                        <p class="role-list" v-for="role in addRoleList">
                                            <span v-show="role.type==1">{{role.name}}(通用)</span>
                                            <span v-show="role.type==2">{{role.name}}/{{role.groupName}}</span>
                                        </p>
                                    </div>
                                </el-form-item>
                                <div class="bottom-details">
                                    <p :title="ruleForm.wechatId==''||ruleForm.wechatId==null?'未绑定':'已绑定'">公众号: {{ruleForm.wechatId==""||ruleForm.wechatId==null?"未绑定":"已绑定"}}</p>
                                    <p :title="ruleForm.mobile==''||ruleForm.mobile==null?'未绑定':'已绑定'+ruleForm.mobile">手机号: {{ruleForm.mobile==""||ruleForm.mobile==null?"未绑定":ruleForm.mobile}}</p>
                                    <p :title="ruleForm.loginTime?changeTime(ruleForm.loginTime):'未登录'">上一次登录时间:
                                        <span v-if="ruleForm.loginTime" style="font-size: 13px;">{{changeTime(ruleForm.loginTime)}}</span>
                                        <span v-if="!ruleForm.loginTime">未登录</span>
                                    </p>
                                </div>
                            </div>
                        </el-form>
                    </div>
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSet.includes('userEdit')||$store.state.isLook||ruleForm.id==$store.state.userData.id" @click="editUser('editForm')" id="yesEdit">确定</el-button> <el-button @click="close('edit')" id="noEdit">取消</el-button></p>
                </div>
            </div>
            <!-- 添加角色 -->
            <div class="popup-role" v-show="roleShow">
                <div class="popup-title">
                    添加角色<i><img :src="notes" title="可通过角色名后面的“添加”、“删除”按钮编辑已选角色列表，“添加”和“删除”按钮在鼠标指向角色名时显示。" class="notes top-2"></i><i class="el-icon-circle-close close" @click="roleShow=false" id="closeRole"></i>
                    <div class="content-box">
                        <div class="roleTree tree p-l-0">
                            <p class="roleTree-top">所属组织</p>
                            <div class="tree-box left-17">
                                <el-tree :indent='0' :data="orSuperiorData" node-key="id" :props="defaultProps" :default-expand-all="true" @node-click="getRole">
                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                        <i><img :src="data.type == 1 ? branch1 : data.type == 2 ? location1 : area1" class="tree-icon"></i>
                                        <span>{{ node.label }} <span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                    </span>
                                </el-tree>
                            </div>
                            <!-- <div class="or-Superior">
                                <el-tree :data="$store.state.treeData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                        <i><img :src="data.type == 1 ? branch1 : data.type == 2 ? location1 : area1" class="tree-icon"></i>
                                        <span>{{ node.label }}</span>
                                    </span>
                                </el-tree>
                            </div> -->
                        </div>
                        <div class="role-selecting">
                            <p class="roleTree-top">可选角色</p>
                            <div class="selecting-box" v-show="roleBoxShow">
                                <div class="role-option-box">
                                    <p class="c-pointer"><i><img :src="select" class="select-icon"></i> 通用</p>
                                    <p v-for="curRole,c in currencyRole" class="role-option currency c-pointer" @mouseover="roleCode = curRole.id" :tabindex="curRole.id">
                                        <i><img :src="role1" class="role-icon"></i>
                                        {{curRole.name}}
                                        <i v-show="curRole.id == roleCode && !addRoleIdList.includes(curRole.id)"><img :src="add" title='添加' class="add-icon" @click="addRole(curRole)" :id="`addCurRole${c}`"></i>
                                        <span class="added" v-show="addRoleIdList.includes(curRole.id)">已添加</span>
                                    </p>
                                </div>
                                <div class="role-option-box">
                                    <p class="c-pointer"><i><img :src="select" class="select-icon"></i> 自定义</p>
                                    <p v-for="cusRole,l in customRole" class="role-option c-pointer" @mouseover="roleCode = cusRole.id" :tabindex="cusRole.id">
                                        <i><img :src="role" class="role-icon"></i>
                                        {{cusRole.name}}
                                        <i v-show="cusRole.id == roleCode && !addRoleIdList.includes(cusRole.id)"><img :src="add" title='添加' class="add-icon" @click="addRole(cusRole)" :id="`addCusRole${l}`"></i>
                                        <span class="added" v-show="addRoleIdList.includes(cusRole.id)">已添加</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="role-selected">
                            <p class="roleTree-top">已选角色</p>
                            <div class="addrole-list">
                                <p v-for="addRole,a in addRoleList" :class="[{ 'currency': addRole.type == 1 },'c-pointer','del-option']" @mouseover="delCode = addRole.id" :tabindex="addRole.id">
                                    <i><img :src="addRole.type==1?role1:role" class="role-icon"></i>
                                    {{addRole.name}} <span v-if="addRole.type==2">/{{addRole.groupName}}</span>
                                    <i v-show="addRole.id == delCode"><img :src="delIcon" title='删除' class="add-icon del-icon" @click="delRole(addRole)" :id="`delRoleList${a}`"></i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="btn-box"><el-button type="primary" @click="editRole" id="yesEditRole">确定</el-button> <el-button @click="closeRole" id="noEditRole">取消</el-button></p>
            </div>
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('function')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <!-- <input type="text" > -->
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('function')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/PublicAssembly/pagination"
    import Organize from "@/components/PublicAssembly/organize"
    export default {
        data() {
            var valiName = (rule, value, callback) =>{
                value = this.ruleForm.displayName
                if(value.length==0){
                    callback(new Error('请输入用户名称'));
                }else if(value.length>32){
                    callback(new Error('用户名称由1~32个字符构成'));
                }else{
                    callback()
                }
                // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
                // if(value == "" ||value==null){
                //     callback(new Error('用户名称不能为空'));
                // }else if(!reg.test(value)){
                //     callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'));
                // }else{
                //     callback();
                // }
            }
            var valirole = (rule,value,callback)=>{
                if(this.ruleForm.roleSet==""||this.ruleForm.roleSet==null){
                    callback(new Error('角色不能为空'));
                }else{
                    callback();
                }
            }
            var valieditrole = (rule,value,callback)=>{
                if(this.ruleForm.roleSet==""||this.ruleForm.roleSet==null){
                    callback(new Error('角色不能为空'));
                }else{
                    callback();
                }
            }
            return {
                dataList:[],
                searchVal:'',
                recoveryName:'用户回收站',
                isBin:false,
                searchBinVal:"",
                recoveryList:[],
                totalCount:1,
                pageSize:0,
                pageNumber:1,
                zuo:require('@/assets/image/index/zuo.png'),
                add:require('@/assets/image/organize/addrole.png'),
                notes:require('@/assets/image/organize/notes.png'),
                delIcon:require('@/assets/image/organize/delete.png'),
                down:require('@/assets/image/organize/down.png'),
                logo:require('@/assets/image/company/logo.png'),
                edit0:require('@/assets/image/organize/edit2.png'),
                edit1:require('@/assets/image/organize/edit4.png'),
                area:require('@/assets/image/organize/area.png'),
                location:require('@/assets/image/organize/location.png'),
                branch:require('@/assets/image/organize/branch.png'),
                area1:require('@/assets/image/company/qyzu.png'),
                branch1:require('@/assets/image/company/ptzu.png'),
                location1:require('@/assets/image/company/jczu.png'),
                select:require('@/assets/image/organize/select.png'),
                nullData:require('@/assets/image/index/nullData.png'),
                role:require('@/assets/image/company/role.png'),
                role1:require('@/assets/image/company/role1.png'),
                state:0,        //控制按钮颜色（企业状态）
                orSuperior:{},      //上级组对象
                orSuperiorData:[],  //所属组tree结构数据
                roleId:null,        //用户当前角色id
                functionSet:[],     //权限列表
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                orCode:null,
                unfreezeShow:false,
                enableShow:false,
                delShow:false,
                disableShow:false,
                resetShow:false,
                addShow:false,
                editShow:false,
                roleShow:false,
                roleBoxShow:false,
                successShow:false,
                recoveryShow:false,
                nowObj:{},          //修改的用户对象
                nowIndex:0,         //修改的用户下标
                ruleForm:{          //表单数据
                    id:null,
                    code:"",
                    userName:"",
                    displayName:"",
                    avatar:"",
                    groupCode:null,
                    groupName:"",
                    roleSet:"",
                    roleNameSet:"",
                    mobile:"",
                    wechatId:"",
                    loginTime:"",
                    note:null,
                    state:Number,
                    loginState:Number,
                    onlineState:Number,
                    activeState:Number,
                },
                verifyForm:{
                    verifyCode:'',
                },
                rules:{         //验证规则
                    displayName:[
                        { required: true, message: '请输入用户姓名', trigger: 'blur' },
                        { max: 32, message: '最大支持32个字符', trigger: 'blur' }],
                    roleNameSet:[{validator: valirole,required: true}],
                    roleSet:[{validator: valieditrole,required: true}],
                    verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }]
                },
                selectShow:false,
                roleTree:[],
                treeCode:null,      //组织树code
                currencyRole:[],    //通用角色列表
                customRole:[],      //自定义角色列表
                roleCode:"",        //当前选中的角色
                delCode:"",         //当前选中要删除的角色
                allRoleList:[],     //所有角色
                addRoleList:[],     //已添加的角色列表
                addRoleIdList:[],
                oldRoleList:[],     //已添加的旧角色列表
                Account:"",         //账号
                displayName:"",     //用户名
                isPageNum:true,
                isCount:true,
                iscode:true,
                oldPageNum:1,
                functionShow:false,
                VerifyArr:[],
                verifyCode:'',
                second:60,
                getCodeShow:true,
                countdownShow:false,
                phone:'',
                time:null,
                oldorSuperior:{},
                protocol:'https:'
            }
        },
        components:{
            Pagination,
            Organize
        },
        created(){
            this.$store.state.activeIndex='/userList'
            this.pageSize=this.$store.state.userConfig.rowsPerPage;
            this.getTree('a');
            this.phone=this.hidePhone(this.$store.state.userData.mobile);
            this.protocol = window.location.protocol
        },
        methods: {
            // 获取列表
            getlist(parm){
                this.get('/User/query',parm).then((res)=>{
                    if(res.success){
                        this.dataList=res.result.data;
                        if(this.isCount){
                            this.totalCount=res.result.totalCount;
                            this.isCount = false
                        }
                    }else{
                        this.$message({
                            message: `获取列表数据失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                })
            },
            //获取组织树
            getTree(type){
                this.get('/Group/getOrganizationTree').then((res)=>{
                    if(res.success){
                        this.roleTree=res.result;
                        this.orCode =  this.roleTree[0].code
                        this.$store.state.treeData = this.roleTree
                        this.orSuperior = this.clone(this.$store.state.treeData[0])
                        this.oldorSuperior = this.clone(this.orSuperior)
                        this.functionSet = this.$store.state.treeData[0].functionSet.split(',')
                        this.$store.state.expandedArr=[]
                        this.expanded(this.$store.state.treeData,1)
                        if(type == 'a'){
                            this.roleId = this.$store.state.treeData[0].roleId
                            this.getlist({pageNumber:1,length:Number(this.pageSize),code:this.orCode});
                            this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
                        }
                        this.orSuperiorData=[]  //初始化树
                        for(let obj of res.result){
                            if(obj.roleId == this.roleId){  //获取当前角色下树数据
                                obj = this.clone(obj)
                                this.orSuperiorData.push(obj)
                                return
                            }
                        }
                    }
                }).then(()=>{
                    this.getAllRole();
                })
            },
            setTree(){
                this.getTree()
            },
            //获取所有角色
            getAllRole(){
                this.get("/Role/getList",{code:this.roleTree[0].code}).then((res)=>{
                    if(res.success){
                      this.allRoleList = res.result;
                    }else{
                      this.$message({
                          type:'warning',
                          message:`获取角色列表失败：${res.message}`
                      })
                    }
                })
            },
            //查询回收站的用户
            getBinList(parm){
                this.get('/User/queryBin',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.recoveryList = res.result.data
                        this.totalCount=res.result.totalCount;
                    }else{
                        this.$message({
                            type:'warning',
                            message:`获取列表数据失败：${res.message}`
                        })
                    }
                })
            },

            //返回用户列表
            toUserList(){
                this.isBin=false;
                this.isCount = true;
                let parm = {pageNumber:1,length:Number(this.pageSize),state:1};
                this.searchVal = '';
                this.getlist(parm)
            },
            //搜索回收站的用户
            searchBin(){
                this.pageNumber=1
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    keyword:this.searchBinVal
                }
                this.getBinList(parm);
            },
            //恢复用户
            recoveryUser(){
                let parm={id:this.nowObj.id};
                this.get('/User/restore',parm).then((res)=>{
                    // console.log(res,parm)
                    if(res.success){
                        this.$message({
                            message: '恢复成功',
                            type: 'success'
                        });
                        this.recoveryList.splice(this.nowIndex,1)
                    }else{
                        this.$message({
                            message: `恢复失败:${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false
                    this.recoveryShow = false
                })
            },
            // 头部标签
            headClick(i){
                // console.log(this.orCode)
                this.isCount = true
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    code:this.orCode,
                    keyword:"",
                    state:null,
                    loginState:null,
                    activeState:null,
                }
                this.state = i
                switch(i){
                    case 1:
                        parm.loginState=1;
                        break;
                    case 2:
                        parm.state=2;
                        break;
                    case 3:
                        parm.loginState=2;
                        break;
                    case 4:
                        parm.activeState=2;
                }
                this.searchVal="";
                this.pageNumber = 1;
                this.getlist(parm);
                // console.log(parm)
            },
            // 修改分页size
            setSize(pageObj){
                this.pageSize=pageObj.size;
                // console.log(this.pageSize)
                let parm={
                    pageNumber:pageObj.number,
                    length:pageObj.size,
                    code:this.orCode,
                    keyword:this.searchVal
                }
                switch(this.state){
                    case 1:
                        parm.loginState=1;
                        break;
                    case 2:
                        parm.state=2;
                        break;
                    case 3:
                        parm.loginState=2;
                        break;
                    case 4:
                        parm.activeState=2;
                }
                this.getlist(parm);
            },
            // 修改页数
            setNum(number){
                //主动修改页数不发送请求
                // console.log(number)
                this.pageNumber=number;
                // console.log(this.pageNumber , this.oldPageNum)
                if(this.pageNumber == this.oldPageNum){
                    return
                }
                this.oldPageNum = number;
                if(this.isBin){
                    let parm = {
                        pageNumber:number,
                        length:this.pageSize,
                        keyword:this.searchBinVal
                    }
                    this.getBinList(parm)
                    // console.log('setNum1')
                }else{
                    let parm ={
                        pageNumber:number,
                        length:this.pageSize,
                        code:this.orCode || this.$store.state.treeData.code,
                        keyword:this.searchVal
                    }
                    switch(this.state){
                        case 1:
                            parm.loginState=1;
                            break;
                        case 2:
                            parm.state=2;
                            break;
                        case 3:
                            parm.loginState=2;
                            break;
                        case 4:
                            parm.activeState=2;
                    }
                    this.getlist(parm);
                    // console.log('setNum2')
                }
                // this.pageNumber = true;
            },
            // 获取的当前组
            setOrId(node){
                // console.log("获取的当前组",node)
                // if(this.orCode == node[0].code){
                //     return
                // }
                this.isCount=true;
                if(node[0].roleId != this.roleId){
                    this.roleId = node[0].roleId
                    this.orSuperiorData = []
                    for(let obj of this.$store.state.treeData){
                        if(node[0].roleId == obj.roleId){   //获取当前角色下的树数据
                            obj = this.clone(obj)
                            this.orSuperiorData.push(obj)
                        }
                    }
                }
                this.orCode=node[0].code;
                this.functionSet = node[1]
                this.orSuperior=this.clone(node[0]);
                this.oldorSuperior = this.clone(this.orSuperior)
                this.isBin = false
                this.searchVal = ''
                this.oldPageNum= 1
                this.pageNumber = 1
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    code:this.orCode,
                    // keyword:"",
                }
                switch(this.state){
                    case 1:
                        parm.loginState=1;
                        break;
                    case 2:
                        parm.state=2;
                        break;
                    case 3:
                        parm.loginState=2;
                        break;
                    case 4:
                        parm.activeState=2;
                }
                this.getlist(parm)
            },
            // 关闭弹窗
            close(name){
                this.verifyForm.verifyCode = ''
                this.$store.state.mask=false;
                this.addRoleList=[];
                this.addRoleIdList = []
                let show = name + "Show";
                this[show]=false;
                this.ruleForm = this.$options.data().ruleForm;
                this.resetRoleSelect()
            },
            //重置选中角色
            resetRoleSelect(){
                if(this.currencyRole.length !=0){
                    for(let obj of this.currencyRole){
                        obj.selectType = false
                    }
                }
                if(this.customRole.length!=0){
                    for(let obj of this.customRole){
                        obj.selectType = false
                    }
                }
            },
            //获取角色
            getRole(data,node){
                //当用户点击同一个组织时不处理
                if(this.treeCode == data.code){
                    return
                }
                this.treeCode = data.code;
                this.get('/Role/getList',{code:data.code}).then((res)=>{
                    let result = res.result;
                    this.currencyRole =[];
                    this.customRole = [];
                    for(let role of result){
                        role.selectType=false;
                        if(role.type == 1){
                            this.currencyRole.push(role);
                        }else{
                            this.customRole.push(role);
                        }
                        // for(let addObj of this.addRoleList){
                        //     if(role.id == addObj.id){
                        //         role.selectType = true
                        //     }
                        // }
                    }
                }).then(()=>{
                    this.roleBoxShow=true;
                })
            },
            // 展开上级组
            showSelect(){
                var box = this.$refs.selectbox;
                this.selectShow=true;
            },
            // 获取用户点击的上级组节点
            selectId(data){
                this.orSuperior=this.clone(data);
                this.selectShow=false;
            },
            //搜索
            search(){
                this.isCount = true
                let parm = {
                    pageNumber:this.pageNumber,
                    length:this.pageSize,
                    code:this.orCode,
                    keyword:this.searchVal,
                }
                switch(this.state){
                    case 1:
                        parm.loginState=1;
                        break;
                    case 2:
                        parm.state=2;
                        break;
                    case 3:
                        parm.loginState=2;
                        break;
                    case 4:
                        parm.activeState=2;
                }
                this.getlist(parm);
            },
            //打开弹窗
            operate(obj,name,i){
                if(name!='edit'&&!this.functionSet.includes('userEdit')||name!='edit'&&obj.userName==this.$store.state.userData.userName||name!='edit'&&this.$store.state.isLook){
                    return
                }
                if(this.VerifyArr.includes(3)&&!this.$store.state.isLook&&this.functionSet.includes('userEdit')){
                    this.$store.state.mask=true
                    this.functionShow = true
                    return
                }
                name += "Show";
                this.nowObj = obj;
                this.nowIndex = i;
                if(name == "editShow"){
                    this.get('/User/get',{id:obj.id}).then((res)=>{
                        if(res.success){
                            this.ruleForm = res.result;
                            this.addRoleList=[];
                            this.addRoleIdList=[];
                            //挂接组
                            this.orSuperior.name=this.ruleForm.groupName;
                            this.orSuperior.code=this.ruleForm.groupCode;
                            let id = this.ruleForm.roleSet;
                            let name = this.ruleForm.roleNameSet;
                            // console.log(id,name)
                            id=id.split(",").map(Number);
                            if(name){
                                name=name.split(",");
                            }
                            let all=this.clone(this.allRoleList);
                            for(i of id){
                                for(obj of all){
                                    if (i == obj.id){
                                        this.addRoleList.push(obj);
                                        this.addRoleIdList.push(obj.id)
                                    }
                                }
                            }
                            this.oldRoleList = this.clone(this.addRoleList);
                            this.$store.state.mask=true;
                            this.editShow=true;
                        }else{
                            this.$message({
                                type:'warning',
                                message:`获取用户数据失败：${res.message}`
                            })
                        }
                    })
                }else{
                    this.$store.state.mask=true;
                    this[name]=true;
                }
            },
            //解冻账号
            unfreeze(){
                let parm ={
                    id:this.nowObj.id
                }
                this.get('/User/unfreeze',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.$message({
                            message: '解冻成功',
                            type: 'success'
                        });
                        this.dataList[this.nowIndex].loginState=1;
                    }else{
                        this.$message({
                            message: `解冻失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false;
                    this.unfreezeShow = false;
                })
            },
            //启用账号
            enable(){
                let parm ={
                    id:this.nowObj.id
                }
                this.get('/User/enable',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.$message({
                            message: '启用成功',
                            type: 'success'
                        });
                        this.dataList[this.nowIndex].state=1;
                    }else{
                        this.$message({
                            message: `启用失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false;
                    this.enableShow = false;
                })
            },
            //删除账号
            del(){
                let parm ={
                    id:this.nowObj.id
                }
                this.get('/User/remove',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.search()
                    }else{
                        this.$message({
                            message: `删除失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false;
                    this.delShow = false;
                })
            },
            //禁用账号
            disable(){
                let parm={
                    id:this.nowObj.id
                }
                this.get('/User/disable',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.$message({
                            message: '停用成功',
                            type: 'success'
                        });
                        this.dataList[this.nowIndex].state=2
                    }else{
                        this.$message({
                            message: `停用失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false;
                    this.disableShow = false;
                })
            },
            //重置账号
            reset(){
                let parm ={
                    id:this.nowObj.id
                }
                this.get('/User/reset',parm).then((res)=>{
                    // console.log(res)
                    if(res.success){
                        this.$message({
                            message: '重置成功',
                            type: 'success'
                        });
                        this.get('/User/get',{id:this.nowObj.id}).then((res)=>{
                            if(res.success){
                                this.dataList[this.nowIndex]=res.result
                            }
                        })
                    }else{
                        this.$message({
                            message: `重置失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false;
                    this.resetShow = false;
                })
            },
            //新增用户
            addUser(name){
                this.$refs[name].validate((valid) => {
                    if(valid){
                        this.ruleForm.groupCode=this.orSuperior.code;
                        this.ruleForm.groupName=this.orSuperior.name;
                        this.ruleForm.loginTime=undefined;
                        let id = null;
                        this.post("/User/create",this.ruleForm).then((res)=>{
                            if(res.success){
                                id=res.result
                            }else{
                                this.$message({
                                    message: `创建失败：${res.message}`,
                                    type: 'warning'
                                });
                                this.$store.state.mask = false;
                            }
                        }).then(()=>{
                            this.addRoleList = this.$options.data().addRoleList;
                            this.addRoleIdList=[];
                            this.oldRoleList = this.$options.data().oldRoleList;
                            this.search()
                            if(id==null){
                                return
                            }
                            this.get('/User/get',{id:id}).then((res)=>{
                                let obj = res.result
                                if(res.success){
                                    this.Account = obj.userName
                                    this.displayName = obj.displayName
                                    this.addShow=false;
                                    this.successShow=true;
                                    this.ruleForm = this.$options.data().ruleForm;
                                    this.$forceUpdate()
                                }else{
                                    this.$message({
                                        message: `获取用户信息失败：${res.message}`,
                                        type: 'warning'
                                    });
                                }

                            })
                        })
                        this.resetRoleSelect();
                        this.addShow = false;
                        this.ruleForm= this.$options.data().ruleForm
                    }
                })
            },
            //编辑用户
            editUser(name){
                this.$refs[name].validate((valid) => {
                    if(valid){
                        this.ruleForm.groupCode=this.orSuperior.code;
                        this.ruleForm.groupName=this.orSuperior.name;
                        this.ruleForm.loginTime = undefined
                        this.post("/User/update",this.ruleForm).then((res)=>{
                            if(res.success){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.dataList[this.nowIndex]=this.clone(this.ruleForm)
                                this.ruleForm = this.$options.data().ruleForm;
                                this.addRoleList = this.$options.data().addRoleList;
                                this.addRoleIdList=[]
                                this.oldRoleList = this.$options.data().oldRoleList;
                            }else{
                                this.$message({
                                    message: `修改失败：${res.message}`,
                                    type: 'warning'
                                });
                            }
                        })
                        this.resetRoleSelect();
                        this.editShow = false;
                        this.$store.state.mask = false;
                    }else{

                    }
                })
            },
            //打开添加角色弹窗
            showRole(name){
                this.addRoleList = this.clone(this.oldRoleList)
                this.roleShow = true;
            },
            //添加角色
            addRole(role){
                role.selectType=true;
                // for(let obj of ){
                //     if(role.id == obj.id){
                //         return
                //     }
                // }
                if(this.addRoleList.includes(role)||this.addRoleIdList.includes(role.id)){
                    return
                }else{
                    this.addRoleList.push(role)
                    this.addRoleIdList.push(role.id)
                    this.$forceUpdate()
                }
                // console.log(this.addRoleList)
            },
            //删除角色
            delRole(role){
                role.selectType=false;
                for(let i in this.addRoleList){
                    if(role.code == this.addRoleList[i].code){
                        this.addRoleList.splice(i,1)
                        this.addRoleIdList.splice(this.addRoleIdList.indexOf(role.id),1)
                    }
                }
            },
            //修改角色
            editRole(){
                let id="",name="";
                this.addRoleIdList=[]
                for(let role of this.addRoleList){
                    id += role.id+",";
                    name += role.name+",";
                    this.addRoleIdList.push(role.id)
                }
                this.ruleForm.roleSet = id.substr(0,id.length - 1);
                this.ruleForm.roleNameSet = name.substr(0,name.length - 1);
                this.roleShow=false;
                this.oldRoleList = this.clone(this.addRoleList) //保存此次角色列表
            },
            //关闭角色弹窗
            closeRole(){
                this.roleShow=false;
                for(let role of this.addRoleList){
                    role.selectType = false
                }
                // console.log(this.oldRoleList)
                this.addRoleList = this.clone(this.oldRoleList) //还原上次添加的角色列表
                this.addRoleIdList=[]
                for(let id of this.oldRoleList){
                    this.addRoleIdList.push(id.id)
                }
            },
            //复制
            copy(){
                let copy = this.$refs.copyTxt
                copy.select(); // 选择对象
                document.execCommand('Copy'); // 执行浏览器复制命令
                this.$message({
                    type:'success',
                    message:'复制成功'
                })
            },
            //回收站
            recovery(){
                // console.log(this.pageSize)
                if(this.isBin){
                    return
                }
                let parm= {pageNumber:1,length:this.pageSize,keyword:""};
                this.searchBinVal= "";
                this.isBin = true;
                this.oldPageNum = 1
                this.state=0
                this.pageNumber = 1
                this.getBinList(parm)
            },
            // 获取验证码
            getCode(){
                this.get('/UserProfile/sendVerifyCode').then((res)=>{
                    if(res.success){
                        this.getCodeShow=false
                        this.countdownShow=true
                        const TIME_COUNT = 60;
                        this.$message({
                            message: '验证码发送成功',
                            type: 'success'
                        });
                        if (!this.timer) {
                            this.second = TIME_COUNT;
                            this.show = false;
                            this.timer = setInterval(() => {
                                if (this.second > 0 && this.second <= TIME_COUNT) {
                                    this.second--;
                                } else {
                                    this.getCodeShow = true;
                                    this.countdownShow=false;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000)
                        }
                    }else{
                        this.$message({
                            message: `验证码发送失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                })
            },
            // 用户提权
            Privilege(){
                this.$refs.verifyCode.validate((valid) => {
                    if (valid) {
                        this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                            if(res.success){
                                this.$message({
                                    message:'提权成功',
                                    type:'success'
                                })
                                this.VerifyArr.splice(this.VerifyArr.indexOf(3),1)
                                localStorage.setItem('verifyCodeModule',this.VerifyArr)
                                this.$store.state.mask=false
                                this.functionShow=false
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                                this.verifyForm.verifyCode = ''
                            }else{
                                this.$message({
                                    message:`提权失败：${res.message}`,
                                    type:'warning'
                                })
                            }
                        })
                    }
                })
            },
        },
        watch: {
            addShow(){
                if(this.addShow){
                    this.orSuperior = this.clone(this.oldorSuperior)
                }
            }
        },
    };
</script>
<style scoped>
    .addMax{
        margin-top: 35px;
    }
    .logo span{
        float: left;
        margin: 0 5px;
    }
    .logo-box{
        position: relative;
        cursor: pointer;
    }
    .logo-box img{
        width: 96px;
        height: 96px;
        border-radius: 5px;
    }
    .logo span:last-child{
        margin-top: 73px
    }
    .or-Superior{
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        padding:0 10px;
        position: relative;
        box-sizing: border-box;
    }
    .red{
        color: #F56C6C;
        line-height: 20px;
        font-size: 14px;
        position: absolute;
        display: none;
    }
    .select-box{
        position: absolute;
        left: -1px;
        top: 32px;
        border: 1px solid #e5e5e5;
        max-height: 303px;
        overflow: auto;
        min-width: 242px;
        max-width: 522px;
        border-radius: 5px;
        z-index: 99;
        background: #fff;
    }
    .or-Superior i{
        float: right;
    }
    .or-Superior img{
        width: 22px;
        margin-top: 6px;
    }
    .root-obj{
        padding-left: 10px;
        cursor:pointer;
        position: relative;
        line-height: 28px;
        top: 4px;
    }
    .root-obj:hover{
        background-color: #f5f7fa;
    }
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        position: absolute;
        top: -43px;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        float: left;
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 36px;
        left: 328px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .bg.t-0{
        margin-top: 0 !important;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
        height: 90%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        max-height: 88% !important;
        height: 88%;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 5px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 5px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 15px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .bg{
        width: 100%;
		margin-top: 42px;
    height: 90%;
    }
    .edit-role{
        color: #5087e4;
        text-align: left;
        position: relative;
        left: -68px;
        font-size: 14px;
        cursor: pointer;
    }
    .edit-role img{
        width: 16px;
        position: relative;
        top:2px;
    }
    .m-t-16{
        margin-top: 16px;
    }
    .m-t-48{
        margin-top: 48px;
    }
    .popup>div{
        position: fixed;
        top: 10%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-406px;
        width: 578px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px !important;
        margin-top: 22px !important;
    }
    .popup-unfreeze .popup-title,.popup-enable .popup-title{
        margin-bottom: 12px;
    }
    .popup-unfreeze,.popup-enable{
        height: 284px;
        position: relative;
    }
    .popup-role{
        width: 893px !important;
        height: 582px;
        margin-left: -446px !important;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    i img.zuo{
        width: 14px;
        position: relative;
        top: 1px;
        margin-right: 5px;
    }
    .organize{
        position: absolute;
        top: 36px;
        bottom: 0;
    }
    .t-0{
        top: 0 !important;
    }
    .w-26{
        width: 26% !important;
    }
    .user-detail{
        /* color: #5087e4; */
        font-size: 14px;
    }
    .bottom-details{
        margin: 18px 0 14px 0;
    }
    .bottom-details p{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .popup-add{
        height: 583px;
    }
    .popup-left,.popup-right{
        width: 242px;
        float: left;
    }
    .popup-right{
        margin-left: 32px;
    }
    .Superior-name{
        display: inline-block;
        width: 195px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .copy-obj{
        opacity: 0;
        position: fixed;
        top: 0;
        left: 0;
    }
    .role-box{
        width: 100%;
        height: 188px;
        border: 1px solid #dedede;
        overflow: auto;
        padding-top: 8px;
        box-sizing: border-box;
    }
    .l-h{
        line-height: 21px;
    }
    .l-h-23{
        line-height: 23px;
    }
    .m-b-5{
        margin-bottom: 5px !important ;
    }
    .copy{
        color: #5087e4;
        cursor: pointer;
    }
    .grey{
        color: #999999;
    }
    .company-bin{
        font-size: 16px;
        text-align: left;
        padding:0 16px;
        margin-top:6px ;
        cursor: pointer;
    }
    .role-list{
        font-size: 14px;
        color: #606060;
        line-height: 24px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .content-box{
        height: 418px;
        border: 1px solid #d2d2d2;
        border-bottom: 0;
    }
    .content-box>div{
        float: left;
        height: 100%;
        width: 277.5px;
        line-height: 34px;
    }
    .roleTree,.role-selecting{
        border-right: 1px solid #d2d2d2;
    }
    .roleTree .el-tree{
        height: 95%;
    }
    .tree-box{
        width: 100%;
        height: 390px;
        overflow: auto;
    }
    .currency{
        color: #073178 !important;
    }
    .roleTree-top{
        text-align: center;
        line-height: 28px;
        color: #fff;
        font-size: 14px;
        background-color: #5087e4;
    }
    img.tree-icon{
        width: 16px !important;
        position: relative;
        top: 3px;
        left: -2px;
    }
    .role-option-box{
        line-height: 28px;
        font-size: 14px;
        margin-bottom: 4px;
        color: #606060;
    }
    .select-icon,.role-icon{
        width: 16px;
        position: relative;
        padding-left: 9px;
        top: 2px;
    }
    .role-icon{
        padding-left: 19px;
    }
    .add-icon{
        width: 16px;
        position: absolute;
        right: 12px;
        top: 10px;
    }
    .del-icon{
        width: 12px;
    }
    .selecting-box,.addrole-list{
        overflow: auto;
        height: 390px;
    }
    .role-option,.del-option{
        position: relative;
    }
    .addrole-list{
        line-height: 28px;
        font-size: 14px;
        /* padding-left: 9px; */
        box-sizing: border-box;
    }
    .role-option:focus{
        outline: none;
        background-color: #f5f5f5;
    }
    .del-option:focus{
        outline: none;
        background-color: #f5f5f5;
    }
    .role-option:hover{
        outline: none;
        background-color: #f5f5f5;
    }
    .del-option:hover{
        outline: none;
        background-color: #f5f5f5;
    }
    .del-option{
        padding-right: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .top-2{
        top: 2px !important;
        left: 10px !important;
    }
    .added{
        font-size: 12px;
        line-height: 32px;
        position: absolute;
        right: 15px;
    }
    .m-t-26{
        margin-top: 24px !important;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .popup-delDevice{
        height: 284px;
    }
    .min-188{
        min-width: 197px;
    }
    .min-44{
        min-width: 44px;
    }
</style>
<!-- 修改默认样式 -->
<style>
    #userList .tree-box .el-tree-node__content{
        padding-left: 14px !important;
    }
    #userList .tree .el-tree-node{
        width: 263px;
        padding-right: 30px;
        box-sizing: border-box;
    }
    #userList .tree-box.left-17 .el-tree-node__children{
        position: relative;
        left: 17px !important;
    }
    #userList .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #userList .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 12px !important;
    }
    #userList .popup .el-form-item__label{
        padding: 0 !important;
    }
    #userList .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #userList .remarks textarea{
        width: 242px !important;
        height: 139px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box  !important;
        line-height: 20px !important;
        overflow: hidden !important;
    }
    #userList .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #userList .search .el-icon-search{
        line-height: 34px !important;
    }
    #userList .p-l-0 .el-tree-node{
        padding-left: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/User/userList.vue